import React from 'react';
import Loader from '../../mweb/Skeletons/Loader/Loader';
import './lazy-section.scss';
import { getSectionData } from 'hb-redux-store/feature/home/home.action';
import { connect } from 'react-redux';
import { HOMEPAGE_SECTIONS } from 'hb-redux-store/util/constantServices';

class LazySection extends React.Component {
  state = {
    section: this.props.section,
    error: false,
    sectionResp: null,
  };

  getSection = sectionResp => {
    const { data, sectionComponent: Section } = this.props;
    if (!sectionResp) return false;
    const { type } = data;
    let sectionProps = this.props.sectionProps || {};
    switch (type) {
      case HOMEPAGE_SECTIONS.CATEGORIES:
        sectionProps.categories = sectionResp;
        break;
      case HOMEPAGE_SECTIONS.USP:
        sectionProps.usps = sectionResp;
        break;
      case HOMEPAGE_SECTIONS.BESTSELLERS:
      case HOMEPAGE_SECTIONS.DEALS_OF_THE_DAY:
      case HOMEPAGE_SECTIONS.COMBO_PRODUCTS:
      case HOMEPAGE_SECTIONS.PRE_ORDER:
      case HOMEPAGE_SECTIONS.RECENTLY_PURCHASED:
      case HOMEPAGE_SECTIONS.RECENTLY_VIEWED:
      case HOMEPAGE_SECTIONS.ATC_AND_CART_ABANDONED:
        sectionProps.products = sectionResp?.products;
        break;
      case HOMEPAGE_SECTIONS.BLOGS:
        sectionProps.blogs = sectionResp;
        break;
      default:
        sectionProps = null;
    }
    if (!sectionProps) return false;
    return <Section {...sectionProps} />;
  };

  componentDidMount() {
    const { data } = this.props;
    this.props.getSectionData({
      apiUri: data?.sectionData?.apiUri,
      successCb: sectionResp => this.setState({ sectionResp }),
      failCb: err => this.setState({ error: true }),
    });
  }

  render() {
    const { error, sectionResp } = this.state;
    if (error) return false;
    if (!sectionResp) {
      return (
        <div className="lazy-section">
          <Loader position="absolute" />
        </div>
      );
    }
    return this.getSection(sectionResp);
  }
}

const mapStateToProps = null;
const mapDispatchToProps = {
  getSectionData,
};

export default connect(mapStateToProps, mapDispatchToProps)(LazySection);
